import React from 'react';

const LoadingSpinner = ({ text = 'Loading...', fullScreen = false }) => {
  const content = (
    <>
      <div className="relative">
        <div className="w-12 h-12 rounded-full border-4 border-gray-700 border-t-purple-500 animate-spin"></div>
        <div className="absolute inset-0 w-12 h-12 rounded-full border-4 border-transparent border-t-pink-500 animate-spin" style={{ animationDelay: '0.2s', animationDirection: 'reverse' }}></div>
      </div>
      <p className="mt-4 text-gray-400 text-sm animate-pulse">{text}</p>
      {fullScreen && (
        <div className="mt-8 text-center">
          <h2 className="text-2xl font-bold bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent mb-2">
            TopBlast
          </h2>
          <p className="text-gray-500 text-xs">Where Degens Become Legends</p>
        </div>
      )}
    </>
  );

  if (fullScreen) {
    return (
      <div className="fixed inset-0 bg-black flex flex-col items-center justify-center z-50">
        {content}
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-[200px] p-8">
      {content}
    </div>
  );
};

export default LoadingSpinner;